<template>
  <div class="transactions-widget">
    <div class="transactions-widget__header">
      <div class="transactions-widget__icon">
        <svg
          width="19"
          height="12"
          viewBox="0 0 19 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.50316 0.341797L9.77428 5.27367H1.23203L5.50316 0.341797Z"
            fill="white"
          />
          <rect
            x="3.85938"
            y="5.27734"
            width="3.28791"
            height="5.75385"
            fill="white"
          />
          <path
            d="M13.6745 11.0312L17.9457 6.09938H9.40342L13.6745 11.0312Z"
            fill="white"
          />
          <rect
            width="3.28791"
            height="5.75385"
            transform="matrix(1 0 0 -1 12.0308 6.0957)"
            fill="white"
          />
        </svg>
      </div>
      <div class="transactions-widget__title">
        {{ $t('transactions_widget.title') }}
      </div>
      <div class="transactions-widget__button">
        <arrow-button @click="goToAnalytics"></arrow-button>
      </div>
    </div>
    <company-analytics-table-v2
      :is-transactions-loading="isTransactionsLoading"
      :has-pagination="false"
      :transactions-list="transactions"
    ></company-analytics-table-v2>
  </div>
</template>

<script>
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import { mapState } from 'vuex'
import CompanyAnalyticsTableV2 from '@vue-app/components/company/analytics/table/CompanyAnalyticsTableV2.vue'

export default {
  name: 'DashboardTransactionsList',
  components: { CompanyAnalyticsTableV2, ArrowButton },
  props: {
    transactions: {
      type: Array,
      default() {
        return []
      },
    },
    isTransactionsLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(['selectedCompany']),
  },
  methods: {
    goToAnalytics() {
      this.$router.push(
        RouteHelper.getRoute('analytics', { companyId: this.selectedCompany })
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
@import '@css-app/mixins';
.transactions-widget {
  background: #ffffff;
  border-radius: 20px;
  &__header {
    padding: 30px 35px;
    display: flex;
    align-items: center;
  }

  &__icon {
    width: 44px;
    height: 44px;

    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 18px;

    background: #64748B;
    border-radius: 15px;

    svg,
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__title {
    font-weight: 500;
    font-size: pxToRem(16);
    line-height: pxToRem(20);
    color: $hint;
    margin-right: 30px;
  }

  &__table {
    width: 100%;
    thead {
      td {
        padding: 22px 11px 34px;
        font-weight: 500;
        font-size: pxToRem(12);
        line-height: pxToRem(16);
        text-transform: uppercase;
        color: #909cb0;
        opacity: 0.7;
        border-top: 1px solid $stroke;

        &:first-child {
          padding-left: 40px;
        }

        &:last-child {
          padding-right: 40px;
        }
      }
    }

    tr {
    }

    td {
      border-bottom: 1px solid $stroke;

      font-weight: 500;
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: #47475e;
      opacity: 0.7;
      padding: 20px 11px;

      &:nth-child(3) {
        max-width: 200px;
        word-break: break-all;
      }

      &:first-child {
        padding-left: 40px;
      }

      &:last-child {
        padding-right: 40px;
      }
    }

    tr {
    }
  }
}
@media screen and (max-width: 992px) {
  .transactions-widget {
    &__table {
      tr {
        td {
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(6),
          &:nth-child(7),
          &:nth-child(8),
          &:nth-child(9) {
            display: none;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.transactions-widget {
  .analytics-table {
    &__header {
      border-top: 1px solid #eff2f8;
      border-radius: 0;
      padding-top: 18px;
    }
  }
}
</style>
